import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

import Header from "../../components/header/Header";
import FooterTeam from "../../components/footer/FooterTeam";
import Hero from "../../components/hero/Hero";
import TeamHeroImage from "../../components/hero/teamHero/TeamHeroImage";
import TeamInformation from "../../components/hero/teamHero/TeamInformation";
import HeroImage from "../../components/hero/HeroImage";
import PopOverMenu from "../../components/ArticleItem/PopOverMenu";
import { InitialState } from "../../store/ArticleStore";

interface BaseLayoutProps {
  children: React.ReactNode;
}

function TeamLayout({ children }: BaseLayoutProps) {
  const { team } = useSelector((state: RootState) => state.teams);
  
  const { articleData } = useSelector(
      (state: RootState) => state.articleStore as InitialState
    ); 

  return (
    <>
      <Header>
        <a href="/">
          <img src={`${process.env.PUBLIC_URL}/assets/logos/logo-dieligadierockt@2x.webp`} alt="Wasserball Logo"
            width="238" height="94"/>
        </a>
      </Header>
      <Hero customClass="hero-team">
        <>
          <HeroImage typeImage="team"/>
          <TeamHeroImage picture={team?.team?.headerimage} headerimage_copyright_text={team?.team?.headerimage_copyright_text}/>
          <TeamInformation
            logo={team?.team?.logo }
            name = { team?.team?.name }
            address = { team?.team?.address }
            zip = { team?.team?.zip }
            city = { team?.team?.city }
            email = { team?.team?.email }
            phone = { team?.team?.phone }
            website = { team?.team?.website }
            description = { team?.team?.aboutcompany }
          />
        </>
      </Hero>
      <main>
         {Array.isArray(articleData) && articleData[0]?.isShared && (
        <div
          className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-slate-100 rounded-lg shadow-lg popover-layer"
          >
            <PopOverMenu articleSlug={articleData[0]?.articleslug} />
          </div>
        </div>
      )}
        {children}
      </main>
      <FooterTeam
        name = { team?.team?.name }
        address = { team?.team?.address }
        zip = { team?.team?.zip }
        city = { team?.team?.city }
        email = { team?.team?.email }
        phone = { team?.team?.phone }
        website = { team?.team?.website }
        map = { team?.team?.googlemaplink }
      />
    </>
  );
}

export default TeamLayout;